import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Base from "../../Config/Base";
import { Footer } from "../footer/footer";
import { API_BASE_CRM_URL, Attachment_BASE_URL } from "../../Config/Config";
import { useNavigate } from "react-router-dom";

// const dummyVisits = [
//   {
//     id: 1,
//     companyName: " Visited PerennialCode IT Solutions",
//     visitedDate: "2026-10-13 11:00 AM",
//     description:
//       "Reviewed software integration requirements and discussed possible solutions for improving workflow.",
//     files: [
//       {
//         id: 101,
//         name: "Meeting Recording.mp3",
//         type: "audio",
//         url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-1.mp3",
//       },
//       {
//         id: 102,
//         name: "Company Photo.jpg",
//         type: "image",
//         url: "https://images.unsplash.com/photo-1497366754035-f200968a6e72",
//       },
//       {
//         id: 103,
//         name: "Visit Report.pdf",
//         type: "pdf",
//         url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       },
//       {
//         id: 104,
//         name: "Visit Location",
//         type: "location",
//         url: "https://www.google.com/maps/search/?api=1&query=Madhapur%2C%20Hyderabad%2C%20Telangana",
//       },
//     ],
//   },
//   {
//     id: 2,
//     companyName: " Visited ABC Technologies",
//     visitedDate: "2026-10-11 12:30 PM",
//     description:
//       "Discussed CRM development progress, new features, and upcoming project requirements with the client.",
//     files: [
//       {
//         id: 201,
//         name: "Voice Notes.mp3",
//         type: "audio",
//         url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-2.mp3",
//       },
//       {
//         id: 202,
//         name: "Office Image.jpg",
//         type: "image",
//         url: "https://images.unsplash.com/photo-1497366811353-6870744d04b2",
//       },
//       {
//         id: 203,
//         name: "Visit Location",
//         type: "location",
//         url: "https://www.google.com/maps/search/?api=1&query=Madhapur%2C%20Hyderabad%2C%20Telangana",
//       },
//     ],
//   },
//   {
//     id: 3,
//     companyName: "Visited Global Business Solutions",
//     visitedDate: "2026-10-09 10:00 AM",
//     description:
//       "Presented the business proposal, discussed pricing, and collected feedback from the client.",
//     files: [
//       {
//         id: 301,
//         name: "Discussion.mp3",
//         type: "audio",
//         url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-3.mp3",
//       },
//       {
//         id: 302,
//         name: "Business Proposal.pdf",
//         type: "pdf",
//         url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       },

//       {
//         id: 303,
//         name: "Visit Location",
//         type: "location",
//         url: "https://www.google.com/maps/search/?api=1&query=Madhapur%2C%20Hyderabad%2C%20Telangana",
//       },
//     ],
//   },
//   {
//     id: 4,
//     companyName: "Visited Sunrise Software Pvt Ltd",
//     visitedDate: "2026-10-07 11:30 AM",
//     description:
//       "Followed up on the current project status, discussed pending issues, and planned the next steps.",
//     files: [
//       {
//         id: 401,
//         name: "Office Photo.jpg",
//         type: "image",
//         url: "https://images.unsplash.com/photo-1497366216548-37526070297c",
//       },
//       {
//         id: 402,
//         name: "Visit Summary.pdf",
//         type: "pdf",
//         url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       },
//       {
//         id: 403,
//         name: "Visit Location",
//         type: "location",
//         url: "https://www.google.com/maps/search/?api=1&query=Madhapur%2C%20Hyderabad%2C%20Telangana",
//       },
//     ],
//   },
//   {
//     id: 5,
//     companyName: "Visited NextGen Infotech",
//     visitedDate: "2026-10-05 3:30 PM",
//     description:
//       "Discussed client feedback, demonstrated recent updates, and identified requirements for future enhancements.",
//     files: [
//       {
//         id: 501,
//         name: "Client Recording.mp3",
//         type: "audio",
//         url: "https://www.soundhelix.com/examples/mp3/SoundHelix-Song-4.mp3",
//       },
//       {
//         id: 502,
//         name: "Client Meeting.jpg",
//         type: "image",
//         url: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4",
//       },
//       {
//         id: 503,
//         name: "Meeting Report.pdf",
//         type: "pdf",
//         url: "https://www.w3.org/WAI/ER/tests/xhtml/testfiles/resources/pdf/dummy.pdf",
//       },
//       {
//         id: 504,
//         name: "Visit Location",
//         type: "location",
//         url: "https://www.google.com/maps/search/?api=1&query=Madhapur%2C%20Hyderabad%2C%20Telangana",
//       },
//     ],
//   },
// ];

const MyVisits = () => {
  const [playingFile, setPlayingFile] = useState(null);
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const getFileIcon = (type) => {
    switch (type) {
      case "audio":
        return "fa-solid fa-headphones";
      case "image":
        return "fa-regular fa-image";
      case "pdf":
        return "fa-regular fa-file-pdf";
      case "location":
        return "fa-solid fa-location-dot";
      default:
        return "fa-regular fa-file";
    }
  };

  const getFileColor = (type) => {
    switch (type) {
      case "audio":
        return "#198754";
      case "image":
        return "#0d6efd";
      case "pdf":
        return "#dc3545";
      case "location":
        return "#e40d22";
      default:
        return "#6c757d";
    }
  };

  const handleFileClick = (file) => {
    if (file.type === "audio") {
      setPlayingFile((prev) => (prev === file.id ? null : file.id));
    } else {
      window.open(file.url, "_blank", "noopener,noreferrer");
    }
  };

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails") || "{}");
  const userId = userDetails?.staffid;

  const [visitData, setVisitData] = useState([]);

  const [loading, setLoading] = useState(false);

  console.log(visitData, "visitDataaaaaaaaaaaaaaaaaaaaaaaaaaaa");

  console.log(visitData, loading);

  const mapVisitData = (items) =>
    items.map((visit) => {
      const files = (visit.files || []).map((file) => {
        const fileName = file.name || "";
        const mimeType = (file.type || "").toLowerCase();
        const extension = fileName.split(".").pop().toLowerCase();

        let type = "file";

        if (mimeType.startsWith("audio/") || ["mp3"].includes(extension)) {
          type = "audio";
        } else if (
          mimeType.startsWith("image/") ||
          ["jpg", "jpeg", "png", "gif", "webp"].includes(extension)
        ) {
          type = "image";
        } else if (mimeType === "application/pdf" || extension === "pdf") {
          type = "pdf";
        }

        return {
          id: file.id,
          name: fileName,
          type,
          url: file.url ? new URL(file.url, Attachment_BASE_URL).href : "",
        };
      });

      // Add the Google Maps location as another clickable file icon.
      if (visit.googleMap) {
        files.push({
          id: `location-${visit.id}`,
          name: "Visit Location",
          type: "location",
          url: visit.googleMap,
        });
      }

      return {
        id: visit.id,
        companyName: visit.relatedName
          ? `Visited ${visit.relatedName}`
          : visit.name || "Visit Details",
        visitedDate: visit.dateadded,
        description: visit.description || "",
        files,
      };
    });

  const fetchData = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${API_BASE_CRM_URL}notes/GetNotesTasks?rel_id=0&rel_type=0&staffid=${userId}`,
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();

      if (data.Status && Array.isArray(data.ResultData)) {
        setVisitData(mapVisitData(data.ResultData));
      } else {
        setVisitData([]);
      }
    } catch (error) {
      console.error("Error fetching visit data:", error);
      setVisitData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, []);

  const navigate = useNavigate();
  useEffect(() => {
    const userDetails = sessionStorage.getItem("userDetails");
    if (!userDetails) {
      navigate("/");
    }
  }, [navigate]);

  return (
    <Base>
      <div className="container-fluid px-2 px-md-3 py-2">
        {/* Header */}
        <div className="d-flex align-items-center justify-content-between mb-3">
          <div>
            <h5 className="mb-1 fw-bold" style={{ color: "#1B2850" }}>
              My Visits
            </h5>
            <small className="text-muted">Your recent company visits</small>
          </div>

          {/* <span
            className="badge rounded-pill px-3 py-2"
            style={{ backgroundColor: "#EAF4FF", color: "#1B2850" }}
          >
            {dummyVisits.length} Visits
          </span> */}
        </div>

        {/* Visit Cards */}
        <div className="row g-2">
          {visitData.map((visit) => (
            <div className="col-12 col-md-6 col-xl-4" key={visit.id}>
              <div
                className="card h-100 shadow-sm"
                style={{
                  border: "1px solid #e5e7eb",
                  borderRadius: 10,
                }}
              >
                <div className="card-body pb-0">
                  {/* Company and Date */}
                  <div className="d-flex align-items-start gap-2 ">
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                      {/* Company Name */}
                      <h6
                        className="mb-1 fw-semibold"
                        style={{
                          fontSize: 14,
                          color: "#111111",
                          overflowWrap: "anywhere",
                        }}
                      >
                        <i className="fa-regular fa-building text-info me-1"></i>{" "}
                        {visit.companyName}
                      </h6>

                      {/* Visited Date and Time */}

                      <div
                        className=" d-flex align-items-center justify-content-between gap-2"
                        style={{ fontSize: 12 }}
                      >
                        {/* Visited Date - Left */}

                        {/* <div className="d-flex align-items-center gap-1">
                          <i className="fa-regular fa-calendar text-primary"></i>
                          <span>
                            {(() => {
                              const [datePart, timePart] =
                                visit.visitedDate.split(" ");
                              const [year, month, day] = datePart.split("-");

                              const formattedDate = new Date(
                                Number(year),
                                Number(month) - 1,
                                Number(day),
                              ).toLocaleDateString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                              });

                              return `${formattedDate}, ${timePart} ${
                                visit.visitedDate.split(" ")[2] || ""
                              }`.trim();
                            })()}
                          </span>
                        </div> */}

                        <div className="d-flex align-items-center gap-1">
                          <i className="fa-regular fa-calendar text-primary"></i>

                          <span>
                            {(() => {
                              const dateValue = visit?.visitedDate;

                              if (!dateValue) return "Date not available";

                              const [datePart, timePart = ""] =
                                dateValue.split(/[T ]/);
                              const [year, month, day] = datePart.split("-");

                              if (!year || !month || !day)
                                return "Invalid date";

                              const time = timePart
                                .split(".")[0]
                                .replace("Z", "");

                              return `${day}-${month}-${year}${time ? ` ${time}` : ""}`;
                            })()}
                          </span>
                        </div>

                        {/* File Icons - Right */}
                        <div className="d-flex align-items-center mb-1 gap-1">
                          {visit.files.map((file) => (
                            <button
                              key={file.id}
                              type="button"
                              className="btn btn-light d-flex align-items-center justify-content-center p-0"
                              onClick={() => handleFileClick(file)}
                              title={
                                file.type === "audio"
                                  ? playingFile === file.id
                                    ? "Hide audio player"
                                    : "Play audio"
                                  : `Open ${file.name}`
                              }
                              style={{
                                width: 30,
                                height: 30,
                                border: "1px solid #e5e7eb",
                                borderRadius: 6,
                                flexShrink: 0,
                              }}
                            >
                              <i
                                className={getFileIcon(file.type)}
                                style={{
                                  fontSize: 15,
                                  color: getFileColor(file.type),
                                }}
                              />
                            </button>
                          ))}
                        </div>
                      </div>

                      <p
                        onClick={() =>
                          setExpandedDescriptions((prev) => ({
                            ...prev,
                            [visit.id]: !prev[visit.id],
                          }))
                        }
                        title={
                          expandedDescriptions[visit.id]
                            ? "Click to collapse"
                            : "Click to read more"
                        }
                        style={{
                          overflowWrap: "anywhere",
                          cursor: "pointer",
                          fontSize: 13,
                          //   marginBottom: 8,
                          display: expandedDescriptions[visit.id]
                            ? "block"
                            : "-webkit-box",
                          WebkitLineClamp: expandedDescriptions[visit.id]
                            ? "unset"
                            : 1,
                          WebkitBoxOrient: "vertical",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <i className="fa-regular fa-file-lines me-1 text-secondary"></i>
                        {visit.description || "No description available"}
                      </p>

                      {visit.files
                        .filter(
                          (file) =>
                            file.type === "audio" && playingFile === file.id,
                        )
                        .map((file) => (
                          <div key={file.id} className="">
                            <audio
                              controls
                              autoPlay
                              preload="none"
                              style={{ width: "100%", height: 36 }}
                            >
                              <source src={file.url} type="audio/mpeg" />
                            </audio>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <Footer></Footer>
    </Base>
  );
};

export default MyVisits;
